<template>
    <ValidationObserver ref="form">
        <div ref="login" class="box box-w-1" @keyup.enter="login">
            <div class="box-inner">
                <h2>Applicant Login</h2>
                <div class="text-center">
                    <p>Your email is already registered in the system. <br> Enter the last 4 digits of your Social
                        Security Number for authentication</p>
                </div>
                <div class="form">
                    <div class="row">
                        <ValidationProvider name="SSN" rules="required|min:4|max:4" v-slot="{errors}" class="col-lg-12">
                            <div class="form-group form-group-1">
                                <input type="password" class="form-control" v-model="form.ssn"
                                       placeholder="Last 4 digit of social security number">
                                <FormError :error="errors[0]" name="SSN"></FormError>
                            </div>
                        </ValidationProvider>

                        <div class="col-12">
                            <button class="btn btn--secondary w-100" @click="login">Login</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
import LoginFormService from "../services/LoginFormService";

export default {
    name: 'ApplicationLoginForm',
    props: {
        email: String,
    },
    data() {
        return {
            form: {
                email: this.email,
                ssn: null,
            }
        }
    },
    methods: {
        async login() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showErrorMessage("Please fill all fields correct");
                return;
            }
            try {
                const response = await LoginFormService.applicationLogin(this.form)
                if (response.status === 200) {
                    if (response.data.register_complete) {
                        window.location.href = `/employee/login`;
                    } else {
                        this.$showSuccessMessage('Successful registration');
                        setTimeout(() => {
                            window.location.href = `/application-step-${response.data.step}`;
                        }, 1000)
                    }
                }
            } catch (error) {
                if (error) {
                    this.$showErrorMessage(`${error.response.data.error}`);
                }
            }
        }
    }
}

</script>

<style scoped>

</style>
